import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";

export class AssetRACIReport{

    @ApiProperty()
    @IsOptional()
    assetId?: number;

    @ApiProperty()
    @IsOptional()
    employeeId?: number;

    @ApiProperty()
    @IsOptional()
    ownerOfAsset?: string;

    @ApiProperty()
    @IsOptional()
    assetSupplier?: string;

    @ApiProperty()
    @IsOptional()
    reportingManager?: string;

    @ApiProperty()
    @IsOptional()
    plant?: number;


    @ApiProperty()
    location: string;

    @ApiProperty()
    assetCategory: string;


    @ApiProperty()
    status: string;

    @ApiProperty()
    assetType? : string;

}